export default {
  title: 'Profil',
  fields: {
    name: {
      label: 'Nume',
      placeholder: 'Introduceți numele restaurantului',
    },
    short_name: {
      label: 'Nume scurt',
      placeholder: 'Introduceți numele scurt al restaurantului',
      tooltip:
        'Uneori numele implicite ale restaurantelor sunt foarte lungi și pot conține informații secundare, astfel că în unele cazuri (ex. pentru notificări mai scurte) este necesar un nume mai scurt',
    },
    phone_number: {
      label: 'Număr de telefon',
      placeholder: 'Introduceți numărul de telefon al restaurantului',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Introduceți e-mailul restaurantului',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug brand',
    },
    language: {
      label: 'Limbă',
      placeholder: 'Implicit al grupului',
      tooltip:
        'Limba pe care clienții o văd pe magazinul acestui restaurant și cea implicită pentru personal. Lăsați gol pentru a urma limba brandului. Personalul își poate alege totuși propria limbă pentru propria vizualizare.',
    },
    sms_name: {
      label: 'Nume SMS',
      placeholder: 'Nume afișat SMS',
    },
    instagram_link: {
      label: 'Link Instagram',
      placeholder: 'Introduceți linkul Instagram al restaurantului',
    },
    website_link: {
      label: 'Link site web',
      placeholder: 'Introduceți linkul site-ului restaurantului',
    },
    impressum_link: {
      label: 'Link Impressum',
      placeholder: 'Introduceți linkul Impressum al restaurantului',
    },
    timezone: {
      label: 'Fus orar',
      placeholder: 'Caută un oraș sau fus orar',
      tooltip:
        'Fusul orar în care funcționează acest restaurant. Determină marcajele temporale ale comenzilor, orele de deschidere și intervalele pentru comenzi programate. A fost setat pe baza adresei restaurantului la creare — corectați-l aici dacă este greșit.',
    },
    time_format: {
      label: 'Format oră',
      placeholder: 'Folosește implicit-ul țării',
      tooltip:
        'Cum sunt afișate orele echipei tale, în tabloul de bord și portalul de comenzi. Lasă gol pentru a urma convenția regiunii restaurantului.',
      options: {
        '12h': '12 ore (5:30 pm)',
        '24h': '24 ore (17:30)',
      },
    },
    primary_color: {
      label: 'Culoare principală',
    },
    restaurant_type: {
      label: 'Tip restaurant și model de servicii',
    },
    cuisine_types: {
      label: 'Categorii alimentare și tipuri de bucătărie',
    },
  },
  test_restaurant: {
    title: 'Restaurant de test',
    description:
      'Marchează acesta ca restaurantul tău de test pentru a încerca tipărirea, e-mailurile, comenzile și integrările în producție. Continuă să funcționeze ca orice alt restaurant și nu este facturat niciodată. Poți avea un singur restaurant de test.',
    description_test:
      'Acesta este restaurantul tău de test. Funcționează ca orice alt restaurant și nu este facturat niciodată. E-mailurile și SMS-urile pentru clienți despre comenzile sale încep cu [TEST].',
    mark: 'Marchează ca restaurant de test',
    remove: 'Elimină marcajul de Test',
    slot_taken: 'Ai deja un restaurant de test ({{name}}). Elimină mai întâi marcajul de Test de la cel existent.',
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    info_updated: 'Setările au fost actualizate cu succes',
  },
};
